import { graphql } from "msw";
import { mockCart } from "../cart/mockCart";
import { locationsList } from "./locationsList";
import {
  UpdateCartLocationMutation,
  UpdateCartLocationMutationVariables,
} from "@cart-app/generated/graphql";

export const handler = graphql.mutation<
  UpdateCartLocationMutation,
  UpdateCartLocationMutationVariables
>("UpdateCartLocation", (req, res, ctx) => {
  const { locationId } = req.variables;
  const foundLocation = locationsList.find(
    (location) => location.id === locationId
  );

  // User error: not shipping to this location
  if (locationId === 100) {
    return res(
      ctx.data({
        updateCartLocation: {
          __typename: "UserError" as const,
          message: "Unfortunately, we're not shipping to the selected location",
        },
      })
    );
  }

  if (foundLocation) {
    return res(
      ctx.data({
        updateCartLocation: {
          ...mockCart,
          shippingLocation: {
            city: foundLocation.suburb,
            postcode: foundLocation.postcode,
          },
        },
      })
    );
  }

  // If no matching location found, send inferred location
  return res(
    ctx.data({
      updateCartLocation: {
        ...mockCart,
        shippingLocation: {
          city: "MELBOURNE",
          postcode: "3000",
        },
      },
    })
  );
});
